<template>
    <div class="landing-page">
        <!-- header -->
        <div class="header">
            <div class="container">
                <div class="menu">
                    <div class="logo">
                        <img class="img-logo-header" src="../../../assets/icons/Logo_HSE_header.png">
                    </div>
                    <div class="menu-list mobile">
                        <i class="pi pi-bars" @click="showMenuListItems = true" v-if="!showMenuListItems"></i>
                        <i class="pi pi-times" @click="showMenuListItems = false" v-else></i>
                    </div>
                    <ul class="menu-list desktop">
                        <li class="menu-items" v-for="(items, index) in menuItems" :key="index">
                            <a @click="scrollMenuItems($event, items.link)">{{items.name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="menu-list-items" v-if="showMenuListItems">
                <ul class="menu-list mobile">
                    <li class="menu-items" v-for="(items, index) in menuItems" :key="index">
                        <a @click="scrollMenuItems($event, items.link)">{{items.name}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="head-banners">
            <div class="container mr-0 background-header">
                <!-- <div class="background-img"></div> -->
            </div>
            <div class="container">
                <div class="text-banner">
                    <div class="header-text-banner">
                        <div>Hệ thống quản lý</div>
                        <div>Rủi ro &amp; Đánh giá an toàn lao động</div>
                    </div>
                    <div class="body-text-banner">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim.
                    </div>
                    <div class="footer-text-banner">
                        <Button label="Xem thêm" class="p-button-success main-style-button" />
                    </div>
                </div>
            </div>
        </div>
        <!-- body -->
        <div class="body">
            <div id="function">
                <div class="function-title">Tính năng nổi bật</div>
                <div class="container">
                    <div class="function">
                        <div class="function-banner desktop">
                            <img class="function-img" src="../../../assets/icons/img_tinhnangnoibat.png"/>
                        </div>
                        <div class="function-box">
                            <div class="function-items" :class="`${[(functions.length-1), (functions.length-2)].includes(index) ? 'last-items' : ''}`" v-for="(items, index) in functions" :key="index">
                                <div class="items-header">
                                    <img class="items-header-icon" :src="items.icon"/>
                                </div>
                                <div class="items-body">
                                    <div class="items-title">
                                        {{items.title}}
                                    </div>
                                    <div class="items-content">
                                        {{items.content}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="planding">
                <div class="function-title">
                    Chọn kế hoạch của bạn
                    <div class="small-text">Đơn giản hoá việc quản lý rủi ro của doanh nghiệp. Cải tiến - Tối ưu - Hiệu quả</div>
                </div>
                <div class="container">
                    <div class="function">
                        <div class="planding-box" :class="{active: (index+1) == Math.round(packages.length/2)}" v-for="(item, index) in packages" :key="index" :id="`page-${item.id}`">
                            <div class="planding-header">
                                <div class="price">{{ $commonFuction.numberFormat(item.fee, 0) }} <span class="currency">đ</span></div>
                                <div class="text-small">/ {{ item.value }} {{ typeArr[item.type] }}</div>
                                <div class="package-name">{{item.name  }}</div>
                            </div>
                            <div class="planding-body">
                                <div class="description-box" v-for="(item, index) in item.descriptions" :key="index">
                                    <div class="description-items">{{ item.description }}</div>
                                </div>
                            </div>
                            <div class="planding-footer">
                                <Button label="Liên hệ ngay" class="p-button-success main-style-button" />
                            </div>
                        </div>
                    </div>
                    <div class="planding-nav mobile">
                        <a @click.stop="clickPlandingNav($event, item.id)" :class="`planding-page-item page-${item.id} ${(index+1) == Math.round(packages.length/2) ? 'active': ''}`" v-for="(item, index) in packages" :key="`index-${item.id}-${index}`"></a>
                    </div>
                </div>
            </div>

            <div class="banners">
                <div class="text-banner">
                    HỆ THỐNG QUẢN LÝ RỦI RO HÀNG ĐẦU VIỆT NAM
                </div>
                <div class="text-banner-small">
                    Bạn còn nhiều thắc mắc, Liên hệ ngay với chung tôi để được tư vấn về dịch vụ, phần mềm và nhiều tính năng liên quan.
                </div>
                <div class="text-banner-hotline">HOTLINE: 0917 26 73 97</div>
            </div>

            <div id="partner">
                <div class="function-title">Đối tác của HSE</div>
                <div class="container">
                    <div class="function">
                        <div class="partner-box" v-for="(partner, index) in partners" :key="index">
                            <div class="partner-header">
                                <img class="partner-logo" :src="partner.logo"/>
                            </div>
                            <div class="partner-body">
                                {{ partner.content }}
                            </div>
                            <div class="partner-footer">
                                <div class="partner-box-line"></div>
                                <a href="#">Techtronic Industries</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- footer -->
        <div class="footer">
            <div class="container row m-auto pt-5">
                <div class="col-12 pt-2 mb-4 px-0">
                    <div class="logo-footer">
                        <img class="img-logo-footer" src="../../../assets/icons/logo_text_white.png"/>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 px-0 pb-3">
                    <div class="company-name">CÔNG TY TNHH DỊCH VỤ AN TOÀN LAO ĐỘNG VN</div>
                    <div class="company-info mt-2 mb-2">
                        <div class="address">Địa chỉ: 502 Đỗ Xuân Hợp, P. Phước Bình, TP. Thủ Đức, TP. Hồ Chí Minh</div>
                        <div class="phone">Điện thoại: (028) 22533507</div>
                        <div class="hotline">Hotline: 0917 267 397 - 0345 062 815 (Ms.Mỹ)</div>
                        <div class="email">Email: <a>cskh@atld.vn</a> - <a>my@atld.vn</a></div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 px-0 pb-3">
                    <div class="about-us">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
                        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
                        Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </div>
                    <div class="icon-social">
                        <img class="img-icon-social" src="../../../assets/icons/icon_fb.svg"/>
                    </div>
                </div>
                <div class="col-12 px-0">
                    <div class="copy-right">
                        Copyright by Engma @2024
                    </div>
                </div>
            </div>
        </div>
        <div class="menu-shadow" v-if="showMenuListItems" @click="showMenuListItems = false"></div>
    </div>
</template>

<script>
import ApiRepository from "@/core/ApiRepository";
import jq from "jquery";
export default {
    name: "landingPage",
    data() {
        return {
            showMenuListItems: false,
            menuItems: [
                {
                    link: "#function",
                    name: "Tính năng"
                },
                {
                    link: "#planding",
                    name: "Kế hoạch"
                },
                {
                    link: "#partner",
                    name: "Đối tác"
                }
            ],
            partners: [
                {
                    logo: require("@/assets/icons/tti.png"),
                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                },
                {
                    logo: require("@/assets/icons/masan.png"),
                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                },
                {
                    logo: require("@/assets/icons/vinacafe.png"),
                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                },
                {
                    logo: require("@/assets/icons/achison.png"),
                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                }
            ],
            packages: [],
            typeArr: {
                "DAY": "ngày",
                "MONTH": "tháng",
                "YEAR": "năm",
                "WEEK": "tuần"
            },
            functions: [
                {
                    icon: require("@/assets/icons/settings_black_24dp.svg"),
                    title: "Cấu Hình Linh Hoạt",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/ssid_chart_black_24dp.svg"),
                    title: "Thống Kê Rõ Ràng",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/work_outline_black_24dp.svg"),
                    title: "Dễ Dàng Thao Tác",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/groups_black_24dp_outline.svg"),
                    title: "Phân Quyền Nội Bộ",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/gpp_good_black_24dp.svg"),
                    title: "An Toàn & Bảo Mật",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                },
                {
                    icon: require("@/assets/icons/money_black_24dp_dollar.svg"),
                    title: "Chính Sách Gói Đa Dạng",
                    content: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum."
                }
            ]
        }
    },
    watch: {
        "$route"() {
            setTimeout(() => {
                const hash = Object.assign({}, this.$route.hash);
                if (hash) {
                    history.pushState("", document.title, window.location.pathname + window.location.search);
                }
            }, 500);
        }
    },
    async created() {
        setTimeout(() => {
            const hash = Object.assign({}, this.$route.hash);
            if (hash) {
                history.pushState("", document.title, window.location.pathname + window.location.search);
            }
        }, 500);
        await this.getListPackage();
        jq("#planding .function").on('scroll',function(){
            var WindowLeft = jq("#planding .function").scrollLeft();
            var stop = false;
            // var width = jq(this).width();
            jq('.planding-box').each(function(i){
                var left = jq('.planding-box').eq(i).offset().left;
                var eleWidth = jq('.planding-box').eq(i).width();
                // var ratio = (screen.width / 425) < 0 ? 1 : screen.width / 425;
                // var scrollLeft = ((width + left + ((left+((45*ratio)*jq('.planding-box').length)) * i) + eleWidth) - (screen.width - 425 + (222*ratio)));
                const isSafari = !!window.GestureEvent
                var scrollLeft = (left + (eleWidth + (10*i)))*i;
                // jq('.planding-box').length
                // if (isSafari) {
                //     scrollLeft = scrollLeft - (50*(jq('.planding-box').length - i));
                // }
                console.log("isSafari", isSafari);
                console.log("scrollLeft", scrollLeft);
                if (scrollLeft < 0) {
                    scrollLeft = 0;
                }
                // console.log("----------");
                // console.log(i);
                console.log("WindowLeft", WindowLeft);
                // console.log(eleWidth*i);
                // console.log((left + eleWidth)*i);
                // console.log("----------");
                if(WindowLeft <= scrollLeft && !stop
                ){
                    jq('.planding-box').removeClass('active');
                    jq('.planding-page-item').removeClass('active');
                    jq('.planding-nav .planding-page-item').eq(i).addClass('active');
                    jq('.planding-box').eq(i).addClass('active');
                    stop = true;
                }
            });
        });
    },
    methods: {
        async getListPackage() {
            var that = this;
            await ApiRepository.post("/_api/packages/package-list").then(async function (response) {
                that.packages = response.data.data.packages;
                that.packages.map(m => {
                    m.descriptions.sort((a, b) => b.ordinal - a.ordinal);
                })
                setTimeout(() => {
                    jq("#planding .function").animate({
                        scrollLeft: '+='+jq(`#page-${that.packages[Math.round(that.packages.length/2) - 1].id}`).offset().left
                    }, 0);
                }, 300);
            })
        },
        async clickPlandingNav(e, id) {
            jq("#planding .function").animate({
                scrollLeft: '+='+jq(`#planding .function #page-${id}`).offset().left
            }, 0);
            e.stopPropagation();
        },
        async scrollMenuItems(e, link) {
            history.pushState("", document.title, window.location.pathname + window.location.search);
            this.showMenuListItems = false;
            jq("html").animate({
                scrollTop: (jq(link).offset().top-65)
            }, 300);
            e.preventDefault();
        },
    }
};
</script>

<style lang="scss" scoped>
html {
  scroll-behavior: smooth;
}
.landing-page {
    position: relative;
    width: 100%;
    height: 100%;
    scroll-behavior: smooth;
    .mobile {
        display: none !important;
    }
    .header {
        position: relative;
        margin-bottom: 0.5em;
        .menu {
            padding-top: 1em;
            display: flex;
            align-items: center;
            z-index: 1000;
            position: relative;
            .logo {
                .img-logo-header {
                    width: 122px;
                    height: 32px;
                }
            }
            .menu-list {
                margin: 0;
                display: flex;
                .menu-items {
                    padding: 0 1em;
                    text-transform: uppercase;
                    list-style: none;
                    a {
                        font-weight: bold;
                        color: #333333;
                        cursor: pointer;
                    }
                    a:hover {
                        color: #0086C4;
                    }
                }
            }
        }
    }
    .head-banners {
        /* position: relative; */
        min-height: calc(800px*1);
        margin-bottom: 0.5em;
        .text-banner {
            top: 10em;
            position: absolute;
            width: 40%;
            z-index: 1000;
            .header-text-banner {
                height: fit-content;
                font-size: calc(44px*1);
                color: #0086C4;
                font-weight: bold;
                margin-bottom: .5em;
            }
            .body-text-banner {
                font-size: calc(14px*1);
                color: #333333;
            }
            .footer-text-banner {
                margin-top: 2em;
                .main-style-button {
                    font-size: calc(16px*1);
                    width: calc(150px*1);
                    height: calc(48px*1);
                }
            }
        }
        .background-header {
            padding: 0;
            width: 100%;
            height: calc(800px*1);
            /* border: 1px solid #eee; */
            position: absolute;
            z-index: 5;
            top: 0;
            right: 0;
            background-image: url('../../../assets/icons/img_banner.png');
            background-position: right;
            background-size: cover;
            /* .background-img {
                width: 100%;
                height: calc(800px*1);
                border: 1px solid #eee;
                position: absolute;
                z-index: 5;
                top: 0;
            } */
            @media (min-width: 1200px) {
                .background-img {
                    max-width: 1140px;
                }
            }
        }
    }

    .body {
        margin-bottom: 0.5em;
        .function-title {
            margin: auto;
            text-align: center;
            color: #333333;
            font-size: calc(40px*1);
            font-weight: bold;
            .small-text {
                color: #666666;
                font-size: calc(14px*1);
                margin-top: 0.2em;
            }
        }
        .function {
            width: 100%;
            margin-top: 0.5em;
            margin-bottom: 2em;
        }
        .banners {
            height: fit-content !important;
            width: 100%;
            // background-color: #0086C4;
            background-image: url('../../../assets/icons/bg_hotline.png');
            background-size: cover;
            padding: 30px;
            text-align: center;
            margin-bottom: 2em;
            .text-banner {
                position: relative !important;
                color: #fff;
                font-size: calc(24px*1);
                font-weight: bold;
                text-transform: uppercase;
            }
            .text-banner-small {
                color: #fff;
                font-size: calc(14px*1);
            }
            .text-banner-hotline {
                color: #F8D46E;
                font-size: calc(24px*1);
                text-transform: uppercase;
                font-weight: bold;
            }
        }
        #function {
            .function {
                display: flex;
                .function-banner {
                    height: auto;
                    flex-basis: 30%;
                    padding-right: 20px;
                    .function-img {
                        width: 100%;
                        height: 100%;
                        /* max-height: calc(546px*1); */
                    }
                }
                .function-box {
                    flex-basis: 70%;
                    display: flex;
                    flex-wrap: wrap;
                    .function-items.last-items {
                        padding-bottom: 0 !important;
                    }
                    .function-items {
                        width: 48%;
                        margin: 0 5px;
                        padding-bottom: 10px;
                        .items-header {
                            width: calc(64px*1);
                            height: calc(64px*1);
                            background-color: #F2F9FC;
                            border-radius: 10px;
                            margin-bottom: 5px;
                            display: flex;
                            .items-header-icon {
                                width: calc(32px*1);
                                height: calc(32px*1);
                                margin: auto;
                                text-align: center;
                            }
                        }
                        .items-body {
                            .items-title {
                                color: #0086C4;
                                font-size: calc(18px*1);
                                font-weight: bold;
                            }
                            .items-content {
                                font-size: calc(14px*1);
                            }
                        }
                    }
                }
            }
        }
        #planding {
            margin-bottom: 2em;
            .function::-webkit-scrollbar {
                display: none;
            }
            .function-title {
                padding: 0 20px;
            }
            .function {
                margin-bottom: unset;
                display: flex;
                justify-content: space-between;
                scroll-behavior: smooth;
                scroll-snap-type: x mandatory;
                flex-wrap: wrap;
                .planding-box {
                    border: 1px solid #eee;
                    /*  width: calc(384px*1); */
                    /* height: calc(384px*1); */
                    flex-basis: 22%;
                    border-radius: 5px;
                    box-shadow: 0px 3px 3px 1px #00000029;
                    padding: 20px;
                    height: fit-content;
                    scroll-margin: 0 20px;
                    scroll-snap-align: center;
                    display: inline-block;
                    margin-bottom: 3em;
                    .planding-header {
                        text-align: center;
                        .price {
                            font-size: calc(30px*1);
                            font-weight: bold;
                            .currency {
                                text-decoration: underline;
                            }
                        }
                        .text-small {
                            color: #6C747E;
                            font-size: calc(14px*1);
                            font-weight: 400;
                        }
                        .package-name {
                            font-size: calc(20px*1);
                            color: #666;
                            font-weight: bold;
                            margin: 1em 0;
                        }
                    }
                    .planding-body {
                        /* width: calc(384px* 0.6); */
                        width: 100%;
                        .description-box {
                            .description-items {
                                color: #6C747E;
                                font-size: calc(14px*1);
                                padding: 5px;
                                white-space: pre-wrap;
                            }
                            .description-items:before {
                                content: "\2713";
                                color: #0086C4;
                                font-weight: bold;
                                margin-right: 5px;
                                font-size: calc(16px*1);
                            }
                        }
                    }
                    .planding-footer {
                        text-align: center;
                        margin-top: 1em;
                    }
                }
            }
            .planding-nav {
                margin: auto;
                text-align: center;
                a {
                    border: 1px solid #B4B4B4;
                    background-color: #fff;
                    border-radius: 50%;
                    padding: 5px;
                    font-size: 0px;
                    margin: 0 5px;
                }
                a.active {
                    background-color: #0086C4;
                }
            }
        }
        #partner {
            .function::-webkit-scrollbar {
                display: none;
            }
            .function {
                padding: 4em 0 0;
                overflow-x: auto;
                overflow-y: hidden;
                white-space: nowrap;
                height: fit-content;
                justify-content: space-between;
                display: flex;
            }
            .partner-box {
                /* height: calc(338px*1); */
                width: calc(300px*1);
                background-color: #F2F9FC;
                border-radius: 20px;
                position: relative;
                margin-right: 1.5em;
                display: inline-block;
                padding: 0 10px 20px;
                .partner-header {
                    margin: auto;
                    text-align: center;
                    border-radius: 50%;
                    border: 4px solid #fff;
                    width: calc(126px*1);
                    height: calc(126px*1);
                    position: absolute;
                    top: -2.5em;
                    background-color: #F2F9FC;
                    left: 0;
                    right: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .partner-logo {
                        /* height: calc(80px*1);
                        width: calc(80px*1); */
                        scale: 0.8;
                    }
                }
                .partner-body {
                    position: relative;
                    white-space: pre-wrap;
                    text-align: center;
                    font-size: calc(14px*1);
                    padding-top: 6em;
                }
                .partner-footer {
                    /* padding: 10px 0 0;
                    border-top: 1px solid #eee; */
                    text-align: center;
                    .partner-box-line{
                        width: 50%;
                        margin: auto;
                        height: 1px;
                        background-color: #eee;
                        margin-top: 5px;
                        margin-bottom: 5px;
                    }
                }
            }
        }
    }

    .footer {
        position: relative;
        bottom: 0;
        height: fit-content;
        width: 100%;
        background-color: #333333;
        color: #EAEAEA;
        padding-bottom: 2.5em;
        .company-name {
            font-size: calc(24px*1);
        }
        .about-us{
            font-size: calc(14px*1);
            margin-bottom: 1em;
        }
        .img-logo-footer {
            width: calc(238px*1);
            height: calc(80px*1);
        }
        .img-icon-social {
            width: calc(40px*1);
            height: calc(40px*1);
        }
        .company-info {
            font-size: calc(14px*1);
            .email {
                a {
                    color: #0086C4;
                    cursor: pointer;
                }
            }
        }
        .copy-right {
            font-size: calc(14px*1);
        }
    }
    @media (min-width: 768px) and (max-width: 920px) {
        .body {
            .function {
                .planding-box {
                    width: calc(768px*1) !important;
                    .planding-body {
                        width: calc(768px* 0.6) !important;
                    }
                }
            }
        }
    }
    @media (min-width: 1000px) and (max-width: 1200px) {
        .body {
            .function {
                .planding-box {
                    width: calc(1000px*1) !important;
                    .planding-body {
                        width: calc(1000px* 0.6) !important;
                    }
                }
            }
        }
    }
    @media (max-width: 1200px) {
        .menu-shadow {
            position: fixed;
            height: 100%;
            width: 100%;
            top: 0;
            z-index: 1111;
            background-color: #000000b5;
        }
        .mobile {
            display: block !important;
        }
        .desktop {
            display: none !important;
        }
        .header {
            position: sticky;
            /* overflow: hidden; */
            top: 0;
            z-index: 9999;
            background-color: #fff;
            border-bottom: 1px solid #eee;
            padding-bottom: 1em;
            box-shadow: 0 0 2px 2px #eeeeee87;
            .menu {
                justify-content: space-between;
            }
            .menu-list-items {
                position: fixed;
                background-color: #fff;
                top: 4em;
                width: 100%;
                border-top: 1px solid #eee;
                .menu-list {
                    margin: 0;
                    padding: 10px;
                    .menu-items {
                        list-style: none;
                        padding: 5px;
                        a {
                            color: #333;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
        .head-banners {
            margin-bottom: 0.5em;
            min-height: fit-content;
            .background-header {
                position: relative;
                height: calc(258px*1);
            }
            .text-banner {
                position: relative;
                width: 100%;
                top: 0;
            }
        }
        .body {
            .function {
                margin-bottom: 1em;
            }
            /* .banners {
                .text-banner-hotline {
                    font-weight: bold;
                }
            } */
            #function {
                .function {
                    .function-box {
                        flex-basis: 100%;
                        .function-items {
                            width: 100%;
                            padding-bottom: 20px !important;
                        }
                        .function-items.last-items {
                            padding-bottom: 20px !important;
                        }
                    }
                }
            }
            #planding{
                .function-title {
                    padding: 0 35px;
                    .small-text {
                        font-weight: 400;
                    }
                }
                .function {
                    overflow-x: auto;
                    overflow-y: hidden;
                    width: 100%;
                    padding-bottom: 1em;
                    flex-wrap: nowrap;
                    justify-content: left;
                    .planding-box {
                        margin: 0 5px;
                        height: auto;
                        scale: .9;
                        .planding-body {
                            width: calc(384px* 0.7);
                        }
                    }
                    .planding-box.active {
                        scale: 1 !important;
                    }
                }
            }
            #partner {
                .function {
                    display: inline-block;
                }
            }
        }
    }
}
</style>